export default "__VITE_ASSET__BDNfpkWH__"